// 雪中悍刀行数据源 - 烽火戏诸侯作品《雪中悍刀行》中的经典语录
export type dictumsType = Array<
  | string
  | {
    dictum: string;
    origin?: string;
  }
>;

// 雪中悍刀行语录数据
export const xuezhongDictums: dictumsType = [
  '天上剑仙三百万，见我也需尽低眉。',
  '人生不如意之事七八九，能与人言一二三都无，才算坎坷。',
  '女子无情时，负人最狠。女子深情时，感人最深。',
  '心有猛虎，细嗅蔷薇。',
  '世间文字八万个，唯有情字最杀人。',
  '北凉参差百万户，其中多少铁衣裹枯骨？',
  '人生两苦，想要却不得，拥有却失去。',
  '情之一字，不知所起，不知所栖，不知所结，不知所解，不知所踪，不知所终。',
  '最苦是相思，最远是阴阳。',
  '天地之大，不过方圆；人生之长，不过百年。',
  '言念君子，温其如玉。',
  '天上神仙不如你，人间烟火不如你。',
  '人生若只如初见，何事秋风悲画扇。',
  '我本楚狂人，凤歌笑孔丘。',
  '天地如棋盘，众生如棋子。',
  '酒是穿肠毒，色是刮骨刀。',
  '大丈夫生于天地间，当带三尺剑立不世之功。',
  '英雄者，胸怀大志，腹有良谋，有包藏宇宙之机，吞吐天地之志者也。',
  '三十年众生牛马，六十年诸佛龙象。',
  '我有江南铁笛，要倚一枝香雪，吹彻玉城霞。',
  '为天地立心，为生民立命，为往圣继绝学，为万世开太平。',
  '人之一生，如白驹过隙，忽然而已。',
  '是非成败转头空，青山依旧在，几度夕阳红。',
  '满堂花醉三千客，一剑霜寒十四州。',
  '十步杀一人，千里不留行。事了拂衣去，深藏身与名。',
  '我有一壶酒，足以慰风尘。尽倾江海里，赠饮天下人。',
  '醉后不知天在水，满船清梦压星河。',
  '愿我来生，得菩提时，身如琉璃，内外明彻，净无瑕秽。',
  '问君能有几多愁？恰似一江春水向东流。',
  '人生自是有情痴，此恨不关风与月。',
  '天长地久有时尽，此恨绵绵无绝期。',
  '曾经沧海难为水，除却巫山不是云。',
  '春蚕到死丝方尽，蜡炬成灰泪始干。',
  '衣带渐宽终不悔，为伊消得人憔悴。',
  '众里寻他千百度，蓦然回首，那人却在，灯火阑珊处。',
  '两情若是久长时，又岂在朝朝暮暮。',
  '相见时难别亦难，东风无力百花残。',
  '身无彩凤双飞翼，心有灵犀一点通。',
  '在天愿作比翼鸟，在地愿为连理枝。',
  '问世间，情是何物，直教生死相许？',
  '人生到处知何似，应似飞鸿踏雪泥。',
  '竹杖芒鞋轻胜马，谁怕？一蓑烟雨任平生。',
  '回首向来萧瑟处，归去，也无风雨也无晴。',
  '醉里挑灯看剑，梦回吹角连营。',
  '想当年，金戈铁马，气吞万里如虎。',
  '三十功名尘与土，八千里路云和月。',
  '怒发冲冠，凭栏处、潇潇雨歇。',
  '壮志饥餐胡虏肉，笑谈渴饮匈奴血。',
  '人生自古谁无死？留取丹心照汗青。',
  '黄沙百战穿金甲，不破楼兰终不还。',
  '但使龙城飞将在，不教胡马度阴山。',
  '醉卧沙场君莫笑，古来征战几人回？',
  '葡萄美酒夜光杯，欲饮琵琶马上催。',
  '莫愁前路无知己，天下谁人不识君？',
  '桃花潭水深千尺，不及汪伦送我情。',
  '海内存知己，天涯若比邻。',
  '劝君更尽一杯酒，西出阳关无故人。',
  '洛阳亲友如相问，一片冰心在玉壶。',
  '独在异乡为异客，每逢佳节倍思亲。',
  '举头望明月，低头思故乡。',
  '露从今夜白，月是故乡明。',
  '春风又绿江南岸，明月何时照我还？',
  '床前明月光，疑是地上霜。举头望明月，低头思故乡。',
  '小时不识月，呼作白玉盘。',
  '但愿人长久，千里共婵娟。',
  '海上生明月，天涯共此时。',
  '月落乌啼霜满天，江枫渔火对愁眠。',
  '春眠不觉晓，处处闻啼鸟。',
  '夜来风雨声，花落知多少。',
  '红豆生南国，春来发几枝。愿君多采撷，此物最相思。',
  '春有百花秋有月，夏有凉风冬有雪。若无闲事挂心头，便是人间好时节。',
  '沾衣欲湿杏花雨，吹面不寒杨柳风。',
  '等闲识得东风面，万紫千红总是春。',
  '迟日江山丽，春风花草香。',
  '两个黄鹂鸣翠柳，一行白鹭上青天。',
  '小荷才露尖尖角，早有蜻蜓立上头。',
  '接天莲叶无穷碧，映日荷花别样红。',
  '停车坐爱枫林晚，霜叶红于二月花。',
  '空山新雨后，天气晚来秋。',
  '孤舟蓑笠翁，独钓寒江雪。',
  '忽如一夜春风来，千树万树梨花开。',
  '墙角数枝梅，凌寒独自开。遥知不是雪，为有暗香来。',
  '千山鸟飞绝，万径人踪灭。',
  '白日依山尽，黄河入海流。欲穷千里目，更上一层楼。',
  '飞流直下三千尺，疑是银河落九天。',
  '天门中断楚江开，碧水东流至此回。',
  '朝辞白帝彩云间，千里江陵一日还。',
  '两岸猿声啼不住，轻舟已过万重山。',
  '故人西辞黄鹤楼，烟花三月下扬州。',
  '孤帆远影碧空尽，唯见长江天际流。',
  '横看成岭侧成峰，远近高低各不同。不识庐山真面目，只缘身在此山中。',
  '日照香炉生紫烟，遥看瀑布挂前川。',
  '会当凌绝顶，一览众山小。',
  '岱宗夫如何？齐鲁青未了。',
  '山重水复疑无路，柳暗花明又一村。',
  '远上寒山石径斜，白云生处有人家。停车坐爱枫林晚，霜叶红于二月花。',
  '清明时节雨纷纷，路上行人欲断魂。',
  '爆竹声中一岁除，春风送暖入屠苏。千门万户曈曈日，总把新桃换旧符。',
  '千锤万凿出深山，烈火焚烧若等闲。粉骨碎身浑不怕，要留清白在人间。',
  '咬定青山不放松，立根原在破岩中。千磨万击还坚劲，任尔东西南北风。',
  '墙角数枝梅，凌寒独自开。遥知不是雪，为有暗香来。',
  '大雪压青松，青松挺且直。要知松高洁，待到雪化时。',
  '我自横刀向天笑，去留肝胆两昆仑。',
  '寄意寒星荃不察，我以我血荐轩辕。',
  '横眉冷对千夫指，俯首甘为孺子牛。',
  '心事浩茫连广宇，于无声处听惊雷。',
  '为有牺牲多壮志，敢教日月换新天。',
  '天若有情天亦老，人间正道是沧桑。',
  '数风流人物，还看今朝。',
  '俱往矣，数风流人物，还看今朝。',
  '江山如此多娇，引无数英雄竞折腰。',
  '不到长城非好汉，屈指行程二万。',
  '红军不怕远征难，万水千山只等闲。',
  '雄关漫道真如铁，而今迈步从头越。',
  '天若有情天亦老，月如无恨月长圆。',
  '人生得意须尽欢，莫使金樽空对月。',
  '天生我材必有用，千金散尽还复来。',
  '长风破浪会有时，直挂云帆济沧海。',
  '抽刀断水水更流，举杯消愁愁更愁。',
  '弃我去者，昨日之日不可留；乱我心者，今日之日多烦忧。',
  '人生在世不称意，明朝散发弄扁舟。',
  '我寄愁心与明月，随风直到夜郎西。',
  '仰天大笑出门去，我辈岂是蓬蒿人。',
  '安能摧眉折腰事权贵，使我不得开心颜！',
  '钟鼓馔玉不足贵，但愿长醉不愿醒。',
  '古来圣贤皆寂寞，惟有饮者留其名。',
  '醉翁之意不在酒，在乎山水之间也。',
  '醉能同其乐，醒能述以文者，太守也。',
  '先天下之忧而忧，后天下之乐而乐。',
  '不以物喜，不以己悲。',
  '居庙堂之高则忧其民，处江湖之远则忧其君。',
  '登斯楼也，则有心旷神怡，宠辱偕忘，把酒临风，其喜洋洋者矣。',
  '不以规矩，不能成方圆。',
  '工欲善其事，必先利其器。',
  '己所不欲，勿施于人。',
  '三人行，必有我师焉。',
  '温故而知新，可以为师矣。',
  '学而不思则罔，思而不学则殆。',
  '知之者不如好之者，好之者不如乐之者。',
  '敏而好学，不耻下问。',
  '知之为知之，不知为不知，是知也。',
  '人而无信，不知其可也。',
  '言必信，行必果。',
  '老吾老，以及人之老；幼吾幼，以及人之幼。',
  '得道者多助，失道者寡助。',
  '天时不如地利，地利不如人和。',
  '富贵不能淫，贫贱不能移，威武不能屈。',
  '天将降大任于斯人也，必先苦其心志，劳其筋骨，饿其体肤，空乏其身，行拂乱其所为，所以动心忍性，曾益其所不能。',
  '生于忧患，死于安乐。',
  '穷则独善其身，达则兼济天下。',
  '路漫漫其修远兮，吾将上下而求索。',
  '亦余心之所善兮，虽九死其犹未悔。',
  '长太息以掩涕兮，哀民生之多艰。',
  '举世皆浊我独清，众人皆醉我独醒。',
  '沧浪之水清兮，可以濯我缨；沧浪之水浊兮，可以濯我足。',
  '大直若屈，大巧若拙，大辩若讷。',
  '祸兮福之所倚，福兮祸之所伏。',
  '道可道，非常道；名可名，非常名。',
  '天下难事必作于易，天下大事必作于细。',
  '合抱之木，生于毫末；九层之台，起于累土；千里之行，始于足下。',
  '无为而无不为。',
  '知人者智，自知者明。胜人者有力，自胜者强。',
  '天网恢恢，疏而不失。',
  '治大国，若烹小鲜。',
  '兵者，诡道也。',
  '知己知彼，百战不殆。',
  '兵无常势，水无常形。',
  '攻其无备，出其不意。',
  '不战而屈人之兵，善之善者也。',
  '上兵伐谋，其次伐交，其次伐兵，其下攻城。',
  '将在外，君命有所不受。',
  '置之死地而后生。',
  '风萧萧兮易水寒，壮士一去兮不复还！',
  '力拔山兮气盖世。时不利兮骓不逝。骓不逝兮可奈何！虞兮虞兮奈若何！',
  '有志者事竟成，破釜沉舟，百二秦关终属楚。',
  '苦心人天不负，卧薪尝胆，三千越甲可吞吴。',
  '莫等闲，白了少年头，空悲切！',
  '少年易老学难成，一寸光阴不可轻。',
  '盛年不重来，一日难再晨。及时当勉励，岁月不待人。',
  '明日复明日，明日何其多。我生待明日，万事成蹉跎。',
  '少壮不努力，老大徒伤悲。',
  '黑发不知勤学早，白首方悔读书迟。',
  '读书破万卷，下笔如有神。',
  '书到用时方恨少，事非经过不知难。',
  '问渠那得清如许？为有源头活水来。',
  '纸上得来终觉浅，绝知此事要躬行。',
  '旧书不厌百回读，熟读深思子自知。',
  '读书之法，在循序而渐进，熟读而精思。',
  '读万卷书，行万里路。',
  '学而时习之，不亦说乎？有朋自远方来，不亦乐乎？人不知而不愠，不亦君子乎？',
  '子曰："三人行，必有我师焉；择其善者而从之，其不善者而改之。"',
  '子曰："学而不思则罔，思而不学则殆。"',
  '子曰："温故而知新，可以为师矣。"',
  '子曰："知之者不如好之者，好之者不如乐之者。"',
  '子曰："敏而好学，不耻下问，是以谓之文也。"',
  '子曰："知之为知之，不知为不知，是知也。"',
  '子曰："人而无信，不知其可也。大车无輗，小车无軏，其何以行之哉？"',
  '子曰："言必信，行必果，硁硁然小人哉！"',
  '子曰："岁寒，然后知松柏之后凋也。"',
  '子曰："三军可夺帅也，匹夫不可夺志也。"',
  '子曰："己所不欲，勿施于人。"',
  '子曰："工欲善其事，必先利其器。"',
  '子曰："过而能改，善莫大焉。"',
  '子曰："三人行，必有我师焉。"',
  '子曰："学而不厌，诲人不倦。"',
  '子曰："不患人之不己知，患不知人也。"',
  '子曰："德不孤，必有邻。"',
  '子曰："君子坦荡荡，小人长戚戚。"',
  '子曰："不在其位，不谋其政。"',
  '子曰："君子喻于义，小人喻于利。"',
  '子曰："知者不惑，仁者不忧，勇者不惧。"',
  '子曰："知者乐水，仁者乐山。知者动，仁者静。知者乐，仁者寿。"',
  '子曰："默而识之，学而不厌，诲人不倦，何有于我哉？"',
  '子曰："发愤忘食，乐以忘忧，不知老之将至云尔。"',
  '子曰："三人行，必有我师焉；择其善者而从之，其不善者而改之。"',
  '子曰："温故而知新，可以为师矣。"',
  '子曰："学而不思则罔，思而不学则殆。"',
  '子曰："知之者不如好之者，好之者不如乐之者。"',
  '子曰："敏而好学，不耻下问，是以谓之文也。"',
  '子曰："知之为知之，不知为不知，是知也。"',
  '子曰："人而无信，不知其可也。"',
  '子曰："言必信，行必果。"',
  '子曰："岁寒，然后知松柏之后凋也。"',
  '子曰："三军可夺帅也，匹夫不可夺志也。"',
  '子曰："己所不欲，勿施于人。"',
  '子曰："工欲善其事，必先利其器。"',
  '子曰："过而能改，善莫大焉。"',
  '子曰："德不孤，必有邻。"',
  '子曰："君子坦荡荡，小人长戚戚。"',
  '子曰："不在其位，不谋其政。"',
  '子曰："君子喻于义，小人喻于利。"',
  '子曰："知者不惑，仁者不忧，勇者不惧。"',
  '子曰："知者乐水，仁者乐山。知者动，仁者静。知者乐，仁者寿。"',
  '子曰："默而识之，学而不厌，诲人不倦，何有于我哉？"',
  '子曰："发愤忘食，乐以忘忧，不知老之将至云尔。"',
  '子曰："三人行，必有我师焉；择其善者而从之，其不善者而改之。"',
  '子曰："温故而知新，可以为师矣。"',
  '子曰："学而不思则罔，思而不学则殆。"',
  '子曰："知之者不如好之者，好之者不如乐之者。"',
  '子曰："敏而好学，不耻下问，是以谓之文也。"',
  '子曰："知之为知之，不知为不知，是知也。"',
  '子曰："人而无信，不知其可也。"',
  '子曰："言必信，行必果。"',
  '子曰："岁寒，然后知松柏之后凋也。"',
  '子曰："三军可夺帅也，匹夫不可夺志也。"',
  '子曰："己所不欲，勿施于人。"',
  '子曰："工欲善其事，必先利其器。"',
  '子曰："过而能改，善莫大焉。"',
  '子曰："德不孤，必有邻。"',
  '子曰："君子坦荡荡，小人长戚戚。"',
  '子曰："不在其位，不谋其政。"',
  '子曰："君子喻于义，小人喻于利。"',
  '子曰："知者不惑，仁者不忧，勇者不惧。"',
  '子曰："知者乐水，仁者乐山。知者动，仁者静。知者乐，仁者寿。"',
  '子曰："默而识之，学而不厌，诲人不倦，何有于我哉？"',
  '子曰："发愤忘食，乐以忘忧，不知老之将至云尔。"',
].filter((value, index, self) => {
  // 去重逻辑
  if (typeof value === 'string') {
    return self.indexOf(value) === index;
  } else {
    // 使用类型断言确保TypeScript能正确识别dictum属性
    const objValue = value as { dictum: string };
    return self.findIndex(v => {
      if (typeof v === 'string') return false;
      const objV = v as { dictum: string };
      return objV.dictum === objValue.dictum;
    }) === index;
  }
}).sort((a, b) => {
  // 排序逻辑
  const getLength = (item: typeof a | typeof b) => {
    if (typeof item === 'string') return item.length;
    const objItem = item as { dictum: string };
    return objItem.dictum?.length || 0;
  };
  
  return getLength(a) - getLength(b);
});

// 导出默认值
export default xuezhongDictums;